import * as retry from 'retry';

export class Retry {
    public static async request(process: () => Promise<void>, retries: number = 2, logger: (error: Error) => void): Promise<any> {
        const operation = retry.operation({
            retries: retries,
            factor: 1,
            minTimeout: 0,
            maxTimeout: 0,
            randomize: false
        });

        return new Promise<any>((resolve, reject) => {
            operation.attempt(() => {
                process().then(resolve).catch((error) => {
                    if (operation.retry(error)) {
                        if (typeof logger === 'function') {
                            logger(error);
                        }
                    } else {
                        reject(error);
                    }
                });
            });
        });
    }
}
